import React, {useState, useRef} from 'react';
import {Modal as ModalComponent, closeModal} from '../../../common/Modal.jsx';
import {Portal} from '../../../common/Portal.jsx';
import CommonSlider from '../../../common/CommonSlider.jsx';
import {FormErrors} from '../../../monitoring_report/fill/FormCollection.jsx';
import styles from '../ProjectPhasesBar.module.scss';

import {
  project_phase_update_deliverable_completion_path,
} from '~/routes';

const MODAL_ID = 'progress-editor-modal';

function ProgressEditorModal(
  {
    handleCloseModal,
    project_id,
    deliverable_id,
    deliverable_title,
    completion_percentage,
    updateDeliverableProgress,
  }) {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [progress, setProgress] = useState(completion_percentage);
  const formRef = useRef(null);

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal();
  };

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);

    jQuery.post(project_phase_update_deliverable_completion_path({
      project_id,
      deliverable_id
    }), jQuery(formRef.current).serialize())
      .done((_) => {
        updateDeliverableProgress(deliverable_id, progress);
        handleClose();
      })
      .fail((res) => {
        let responseJSON = res.responseJSON ? res.responseJSON.errors : {server: [{message: I18n.t('unexpected_error')}]};
        setErrors(responseJSON);
        setSaving(false);
      });
  };

  const handleCompletionPercentage = (value) => {
    setProgress(value);
  };

  return (
    <Portal
      id={MODAL_ID}
      title={deliverable_title}
      onSave={handleSave}
      saving={saving}
      saveLabel={I18n.t('update')}
      onClose={handleClose}
      cancelLabel={I18n.t('close')}
      size='md'
      component={ModalComponent}
    >
      <form ref={formRef}>
        {Object.keys(errors).length > 0 &&
          <FormErrors errors={errors} title={I18n.t('active_validation_errors')} warningLevel={'danger'}/>
        }

        <div className='form-group'>
          <label>{I18n.t('level_of_completion')}</label>
          <CommonSlider
            value={progress}
            onChange={handleCompletionPercentage}
            min={0}
            max={100}
            step={1}
            style={{width: '100%'}}
          />
          <input type='hidden' name={'completion_percentage'} value={progress}/>
        </div>
      </form>
    </Portal>
  );
}

const ProgressEditor = ({project_id, deliverable, editable = false, updateDeliverableProgress = () => {}}) => {
  const {id: deliverable_id, title: deliverable_title, completion_percentage} = deliverable;
  const status = completion_percentage === 100 ? 'completed' : completion_percentage > 0 ? 'in_progress' : 'not_started';

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);

  return (
    <div className={styles.Content}>
      <div
        className={styles.ProgressBar}
        {...(editable && {onClick: handleOpenModal, style: {cursor: 'pointer'}})}
      >
        <div
          className={`${styles.ProgressFill} ${completion_percentage === 100 ? styles.full : completion_percentage > 0 ? styles.partial : styles.defaultColor}`}
          style={{width: `${completion_percentage}%`}}
        />
      </div>
      {openModal &&
        <ProgressEditorModal {...{handleCloseModal, project_id, deliverable_id, deliverable_title, completion_percentage, updateDeliverableProgress}}/>
      }
      <div className={styles.Status}>
        <span>{I18n.t(status)}</span>
        <span {...(editable && {onClick: handleOpenModal, style: {cursor: 'pointer'}})}>
          {completion_percentage}%
        </span>
      </div>
    </div>
  );
}

export default ProgressEditor;
